/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/WorkflowStepForm.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Step
 *
 * PURPOSE:
 * Workflow Step Create / Edit Form
 *
 * ARCHITECTURE:
 * - Bootstrap/AdminLTE
 * - Presentation Component
 * - Controlled Component
 * - No API Calls
 * - No Business Logic
 ******************************************************************************/

import React from "react";

export default function WorkflowStepForm({

    formData,

    errors = {},

    approvalLevels = [],

    rejectActions = [],

    loading = false,

    saving = false,

    onChange,

    onSubmit,

    onCancel,

}) {

    const handleChange = (event) => {

        const {

            name,

            value,

            type,

            checked,

        } = event.target;

        onChange(

            name,

            type === "checkbox"
                ? checked
                : value

        );

    };

    return (

        <form
            onSubmit={onSubmit}
        >

            <div className="row">

                {/* ------------------------------------------------ */}
                {/* Step Name */}
                {/* ------------------------------------------------ */}

                <div className="col-md-6 mb-3">

                    <label className="form-label">

                        Step Name

                        <span className="text-danger">

                            *

                        </span>

                    </label>

                    <input

                        type="text"

                        name="step_name"

                        className={`form-control ${

                            errors.step_name
                                ? "is-invalid"
                                : ""

                        }`}

                        value={
                            formData.step_name || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.step_name && (

                        <div className="invalid-feedback">

                            {errors.step_name}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Sequence */}
                {/* ------------------------------------------------ */}

                <div className="col-md-2 mb-3">

                    <label className="form-label">

                        Sequence

                    </label>

                    <input

                        type="text"

                        className="form-control bg-light"

                        value={
                            formData.sequence_no || "Auto Generated"
                        }

                        readOnly

                    />

                    {errors.sequence_no && (

                        <div className="invalid-feedback">

                            {errors.sequence_no}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Display Order */}
                {/* ------------------------------------------------ */}

                <div className="col-md-2 mb-3">

                    <label className="form-label">

                        Display Order

                    </label>

                    <input

                        type="text"

                        className="form-control bg-light"

                        value={
                            formData.display_order || "Auto Generated"
                        }

                        readOnly

                    />

                </div>

                {/* ------------------------------------------------ */}
                {/* Approval Level */}
                {/* ------------------------------------------------ */}

                <div className="col-md-2 mb-3">

                    <label className="form-label">

                        Approval Level

                        <span className="text-danger">

                            *

                        </span>

                    </label>

                    <select

                        name="approval_level_id"

                        className={`form-control ${

                            errors.approval_level_id
                                ? "is-invalid"
                                : ""

                        }`}

                        value={
                            formData.approval_level_id || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    >

                        <option value="">

                            Select

                        </option>

                        {approvalLevels.map((level) => (

                            <option

                                key={level.approval_level_id}

                                value={level.approval_level_id}

                            >

                                {level.name}

                            </option>

                        ))}

                    </select>

                    {errors.approval_level_id && (

                        <div className="invalid-feedback">

                            {errors.approval_level_id}

                        </div>

                    )}

                </div>

            </div>

            <div className="row">
                            {/* ------------------------------------------------ */}
                {/* Approval Required */}
                {/* ------------------------------------------------ */}

                <div className="col-md-3 mb-3">

                    <div className="form-check mt-4">

                        <input

                            className="form-check-input"

                            type="checkbox"

                            id="approval_required"

                            name="approval_required"

                            checked={
                                Boolean(
                                    formData.approval_required
                                )
                            }

                            onChange={handleChange}

                            disabled={
                                loading || saving
                            }

                        />

                        <label

                            className="form-check-label"

                            htmlFor="approval_required"

                        >

                            Approval Required

                        </label>

                    </div>

                </div>

                {/* ------------------------------------------------ */}
                {/* Allow Delegate */}
                {/* ------------------------------------------------ */}

                <div className="col-md-3 mb-3">

                    <div className="form-check mt-4">

                        <input

                            className="form-check-input"

                            type="checkbox"

                            id="allow_delegate"

                            name="allow_delegate"

                            checked={
                                Boolean(
                                    formData.allow_delegate
                                )
                            }

                            onChange={handleChange}

                            disabled={
                                loading || saving
                            }

                        />

                        <label

                            className="form-check-label"

                            htmlFor="allow_delegate"

                        >

                            Allow Delegate

                        </label>

                    </div>

                </div>

                {/* ------------------------------------------------ */}
                {/* Allow Skip */}
                {/* ------------------------------------------------ */}

                <div className="col-md-3 mb-3">

                    <div className="form-check mt-4">

                        <input

                            className="form-check-input"

                            type="checkbox"

                            id="allow_skip"

                            name="allow_skip"

                            checked={
                                Boolean(
                                    formData.allow_skip
                                )
                            }

                            onChange={handleChange}

                            disabled={
                                loading || saving
                            }

                        />

                        <label

                            className="form-check-label"

                            htmlFor="allow_skip"

                        >

                            Allow Skip

                        </label>

                    </div>

                </div>

                {/* ------------------------------------------------ */}
                {/* Auto Approve */}
                {/* ------------------------------------------------ */}

                <div className="col-md-3 mb-3">

                    <div className="form-check mt-4">

                        <input

                            className="form-check-input"

                            type="checkbox"

                            id="auto_approve"

                            name="auto_approve"

                            checked={
                                Boolean(
                                    formData.auto_approve
                                )
                            }

                            onChange={handleChange}

                            disabled={
                                loading || saving
                            }

                        />

                        <label

                            className="form-check-label"

                            htmlFor="auto_approve"

                        >

                            Auto Approve

                        </label>

                    </div>

                </div>

            </div>

            <div className="row">

                {/* ------------------------------------------------ */}
                {/* Escalation After Hours */}
                {/* ------------------------------------------------ */}

                <div className="col-md-4 mb-3">

                    <label className="form-label">

                        Escalation After (Hours)

                    </label>

                    <input

                        type="number"

                        min="0"

                        name="escalation_after_hours"

                        className={`form-control ${

                            errors.escalation_after_hours
                                ? "is-invalid"
                                : ""

                        }`}

                        value={
                            formData.escalation_after_hours || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.escalation_after_hours && (

                        <div className="invalid-feedback">

                            {errors.escalation_after_hours}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Reject Action */}
                {/* ------------------------------------------------ */}

                <div className="col-md-4 mb-3">

                    <label className="form-label">

                        Reject Action

                    </label>

                    <select

                        name="reject_action"

                        className={`form-control ${

                            errors.reject_action
                                ? "is-invalid"
                                : ""

                        }`}

                        value={
                            formData.reject_action || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    >

                        <option value="">

                            Select Reject Action

                        </option>

                        {rejectActions.map((action) => (

                        <option

                            key={action.value}

                            value={action.value}

                        >

                            {action.label}

                        </option>

                    ))}

                    </select>

                    {errors.reject_action && (

                        <div className="invalid-feedback">

                            {errors.reject_action}

                        </div>

                    )}

                </div>

                {/* ------------------------------------------------ */}
                {/* Reject Step Sequence */}
                {/* ------------------------------------------------ */}

                <div className="col-md-4 mb-3">

                    <label className="form-label">

                        Reject Step Sequence

                    </label>

                    <input

                        type="number"

                        min="1"

                        name="reject_step_sequence"

                        className={`form-control ${

                            errors.reject_step_sequence
                                ? "is-invalid"
                                : ""

                        }`}

                        value={
                            formData.reject_step_sequence || ""
                        }

                        onChange={handleChange}

                        disabled={

                            loading ||

                            saving ||

                            formData.reject_action !== "RETURN_TO_PREVIOUS_STEP"

                        }

                    />

                    {errors.reject_step_sequence && (

                        <div className="invalid-feedback">

                            {errors.reject_step_sequence}

                        </div>

                    )}

                </div>

            </div>

            <div className="row">
                            {/* ------------------------------------------------ */}
                {/* Remarks */}
                {/* ------------------------------------------------ */}

                <div className="col-md-12 mb-3">

                    <label className="form-label">

                        Remarks

                    </label>

                    <textarea

                        name="remarks"

                        rows="3"

                        className={`form-control ${

                            errors.remarks
                                ? "is-invalid"
                                : ""

                        }`}

                        value={
                            formData.remarks || ""
                        }

                        onChange={handleChange}

                        disabled={
                            loading || saving
                        }

                    />

                    {errors.remarks && (

                        <div className="invalid-feedback">

                            {errors.remarks}

                        </div>

                    )}

                </div>

            </div>

            <div className="row">

                {/* ------------------------------------------------ */}
                {/* Active */}
                {/* ------------------------------------------------ */}

                <div className="col-md-12 mb-3">

                    <div className="form-check">

                        <input

                            className="form-check-input"

                            type="checkbox"

                            id="is_active"

                            name="is_active"

                            checked={
                                Boolean(
                                    formData.is_active
                                )
                            }

                            onChange={handleChange}

                            disabled={
                                loading || saving
                            }

                        />

                        <label

                            className="form-check-label"

                            htmlFor="is_active"

                        >

                            Active

                        </label>

                    </div>

                </div>

            </div>

            <hr />

            {/* ------------------------------------------------ */}
            {/* Footer */}
            {/* ------------------------------------------------ */}

            <div className="d-flex justify-content-end">

                <button

                    type="button"

                    className="btn btn-secondary me-2"

                    onClick={onCancel}

                    disabled={saving}

                >

                    Cancel

                </button>

                <button

                    type="submit"

                    className="btn btn-primary"

                    disabled={
                        loading || saving
                    }

                >

                    {saving
                        ? "Saving..."
                        : "Save Step"}

                </button>

            </div>
                    </form>

    );

}